module.exports = __webpack_public_path__ + "static/media/close.e2cd1206.svg";